import { SVGProps } from 'react';

const ResetPasswordIcon = ({
  height = '115px',
  width = '115px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 115 115'
    {...props}
  >
    <g transform='translate(-162 -247)'>
      <circle
        cx='57.5'
        cy='57.5'
        r='57.5'
        transform='translate(162 247)'
        fill='#dff8d4'
      />
      <circle
        cx='45'
        cy='45'
        r='45'
        transform='translate(174 259)'
        fill='#60b96b'
        opacity='0.23'
      />
      <path
        d='M29.627,14.673H27.993V11.4a8.17,8.17,0,1,0-16.341,0v3.268H10.018A3.278,3.278,0,0,0,6.75,17.941V34.282a3.278,3.278,0,0,0,3.268,3.268H29.627A3.278,3.278,0,0,0,32.9,34.282V17.941A3.278,3.278,0,0,0,29.627,14.673Zm-9.8,14.87a3.268,3.268,0,1,1,3.268-3.268A3.278,3.278,0,0,1,19.823,29.543Zm5.066-14.87H14.757V11.4a5.066,5.066,0,0,1,10.132,0Z'
        transform='translate(199.178 284.108)'
        fill='#60b96b'
      />
    </g>
  </svg>
);

export default ResetPasswordIcon;
